module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 15\"><path fill=\"currentColor\" d=\"M10.58 9.17l3.18-2.72-4.17-.32L8 2.27 6.4 6.13l-4.16.32 3.18 2.72-.98 4.06L8 11.03l3.56 2.2-.98-4.06zM8 12.5l-3.42 2.1a1 1 0 0 1-1.5-1.08l.95-3.91-3.07-2.6a1 1 0 0 1 .58-1.77l4-.3 1.54-3.72a1 1 0 0 1 1.84 0l1.54 3.72 4 .3A1 1 0 0 1 15.04 7l-3.07 2.6.95 3.92a1 1 0 0 1-1.5 1.08L8 12.51z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-star-small.svg
// module id = 912
// module chunks = 0